<template>
    <div class="addteamUser">
        <div class="add_container">
            <div class="fai_notext_field  flex align-cen">
                <div class="fai_notext_field_label">成员权限</div>
                <el-radio-group v-model="radio" style="margin-left:50px">
                <el-radio :label="2">管理员</el-radio>
                <el-radio :label="0">使用者</el-radio>
            </el-radio-group>
            </div>
             <div class="fai_notext_field  flex align-cen">
             <div class="fai_notext_field_label" style="line-height:40px">成员分类</div>
             <div class="addform ">
                 <el-checkbox-group v-model="checkList">
                    <el-checkbox :label="item.id" v-for="item in itemList1">{{item.name}}</el-checkbox>
                </el-checkbox-group>
             </div>
         </div>
            <div class="fai_notext_field flex align-cen" v-if="radio==2">
            <div class="fai_notext_field_label">管理权限</div>
            <div style="color:rgb(255,74,59);margin-left:50px;font-size:12px">能够编辑管理团队人员，使用所有购买的应用</div>
            </div>
         <!-- <div class="fai_notext_field  flex">
             <div class="fai_notext_field_label" style="line-height:40px">产品权限</div>
             <div class="addform">
                <el-tree
            ref="tree"
            :data="itemList"
            show-checkbox
            node-key="id"
            :default-expand-all="expandall"
            :default-checked-keys="checkTrue"
            :props="defaultProps"
            @check="checkHandler"
            v-loading = "loading"
            >
            </el-tree>
             </div>
         </div> -->
         <div class="btm_btn_box flex align-cen">
            <div class="fai_submit_btn" @click="copyLink">生成链接</div>
            <div class="fai_cancel_btn" @click="reback">取消</div>
         </div>
        </div>
    </div>
</template>
<script>
import { getappAuth,geAccountGroup} from "@/api/enterprise/index"; // 权限树列表、成员分类
export default {
    name:'addteamUser',
    data () {
        return {
            loading:false,
            nowDate:'',
            endDate:'',
            expandall:true,
            radio:0,
            bussID:'',
            currentId:'',
            itemList:[], 
            itemList1:[], 
            checkTrue:[],
            currentUserInfo:'',
            businessInfo:'',
            defaultProps: {
          children: 'appAuthAccountVOList',
          label: 'name',
        },
         authList:[],
         checkList:[]
        }
    },
    created () {
     const businessInfo = this.$locaStorage.setAge().get('businessInfo')
     const currentUserInfo = this.$locaStorage.setAge().get('currentUserInfo')
     this.currentUserInfo = currentUserInfo
     this.businessInfo = businessInfo
     this.bussID = businessInfo.id
     this.currentId = currentUserInfo.id
     this.getGroup()
    },
    methods: {
        // 获取成员分类
        getGroup(){
             geAccountGroup({
                id:this.bussID,
                name:'',
               accountId:''
            })
            .then(res =>{
               this.checkList = []
                this.itemList1 = [...res.data]
            })
        },
        // 生成链接
        copyLink(){
            if(this.checkList && !this.checkList.length) return this.$util.Notifi('请至少选择一个分类', "error", "fa-exclamation-circle");   
            this.nowDate = this.$util.getTimeData(0);
            this.endDate = this.$util.getTimeData(360);
            let dataJson = {
                businessId:this.bussID,
                isAdmin:this.radio,
                avatar:this.currentUserInfo.avatar,
                shareName:this.currentUserInfo.name,
                nowDate:this.nowDate,
                groupIds:this.checkList
            }
          
            let jsonString = JSON.stringify(dataJson);  
            const encryptQuery = encodeURIComponent(jsonString) //链接参数加密
        let str = '分享人: ' + this.currentUserInfo.name + '\n团队名称：' + this.businessInfo.name + '\n邀请链接：' + this.$config.prUrl + '#/webenterprise/inviteAccount?dataJson=' + encryptQuery + '\n链接有效期：' + this.nowDate + '~~~' + this.endDate
              let _self = this
                this.$copyText(str).then(
                    function(e) { 
                      _self.$util.Notifi('复制成功','success','fa-check')
                    },
                    function(e) {
                    _self.$util.Notifi('复制失败','error','fa-exclamation-circle'); 
                    }
                );
        },
        // 返回上一页
        reback(){
            this.$router.push('/webenterpriseManage/teamAdmin')
        },
        // 获取应用树列表
        gethisList(){
            this.loading = true
             getappAuth({id:this.bussID,accountId:''},'enterprise')
            .then(res =>{
               this.loading = false
               this.itemList = res.data
               this.getAllNodeId(res.data)
            //    if(this.itemList){
            //     for (const key in res.data) {
            //        for (const key1 in res.data[key].appAuthAccountVOList) {
            //         for (const key2 in res.data[key].appAuthAccountVOList[key1].appAuthAccountVOList) {
            //             if (res.data[key].appAuthAccountVOList[key1].appAuthAccountVOList[key2]) {
            //                res.data[key].appAuthAccountVOList[key1].appAuthAccountVOList[key2].name = res.data[key].appAuthAccountVOList[key1].appAuthAccountVOList[key2].name + res.data[key].appAuthAccountVOList[key1].appAuthAccountVOList[key2].accountNum
                            
            //             }
            //         }
            //        }
            //     }
            //    }
            })
            .catch(err =>{this.loading = false})
        },
             // 递归改变子集name
         getAllNodeId (moduleDataList) {
            let list = moduleDataList.map((item)=>{
                    if(item.appAuthAccountVOList){
                        this.getAllNodeId(item.appAuthAccountVOList)
                    }
                    item.isApp == 1 ? item.name = item.name + '【可分配' + item.accountNum + '个账号】' : item.name = item.name
                    item.accountNum && item.accountNum <= 0 ? item['disabled'] = true : item['disabled'] = false
                    return item
                })
                console.log(list)
                return list
         },
        checkHandler(...value){
            this.authList = []
            let checkedKeys = this.$refs.tree.getCheckedNodes()
             for (let i in checkedKeys) {
                if(checkedKeys[i].isApp == 1){
                this.authList.push(checkedKeys[i].id)
                }
            }
            // truu勾选的方法
        },
    },
}
</script>
<style lang="scss" scoped>
.addteamUser{
    padding-top: 30px;
    font-weight: 400;
    .add_container{
     position: relative;
    margin: 0 auto;
    width: 1000px;
    background-color: #fff;
    box-shadow: 0 0 7px 0 rgba(197,197,197,0.34);
    padding: 40px 105px;
    box-sizing: border-box;
    margin-bottom: 40px;
    .fai_notext_field {
    min-height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
    .fai_notext_field_label{
    font-size: 12px;
    color: #90909e;
    }
    }
    .btm_btn_box{
        margin-top: 30px;    
        justify-content: center;
    .fai_submit_btn,.fai_cancel_btn{
        width: 270px;
            height: 40px;
    line-height: 40px;
    background: rgba(255,255,255,1);
    border-radius: 2px;
    box-sizing: content-box;
    font-size: 16px;
    cursor: pointer;
    transition: all .3s linear;
    text-align: center;
    }
    .fai_submit_btn{
        border: 1px solid rgba(1,87,255,1);
        color: #0157ff;
    }
    .fai_cancel_btn{
    border: 1px solid rgba(1,87,255,1);
    color: #0157ff;
    border: 1px solid #dadada;
    color: #90909e;
    margin-left: 30px;
    }
    }
    }
}
::v-deep {
  .addform{
    margin-left: 50px;
     .el-checkbox{
        display: block !important;
        margin-bottom: 5px;
    }
      .el-tree-node__content{
          height: 40px !important;
      }
      .el-tree{
          display: flex;
          flex-wrap: wrap;
      }
  }
}
</style>